"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowRenderer = RowRenderer;
exports.ProductPropertyRowRenderer = ProductPropertyRowRenderer;
const React = __importStar(require("react"));
const AuthorizationTools = __importStar(require("@genesys/shared/lib/authorization"));
const PropertiesSelectorElements = __importStar(require("./elements"));
const product_property_selector_1 = require("./product-property-selector");
const value_source_selector_1 = require("../value-source-selector");
const property_label_1 = require("./property-label");
const UserProfile = __importStar(require("../user-profile"));
function RowRenderer({ fieldGroup, fieldName, hidePropertyName, selectorInfo }) {
    return (React.createElement(UserProfile.UserProfile, null, user => {
        const title = AuthorizationTools.checkPermission(user.applicationClaims, AuthorizationTools.genesysUserClaims.developer)
            ? "GroupName: " + fieldGroup + "\nFieldName: " + fieldName
            : undefined;
        return (React.createElement("tr", null,
            !hidePropertyName && (React.createElement(property_label_1.PropertyLabel, { labelText: selectorInfo.label, isHidden: selectorInfo.isHidden })),
            React.createElement("td", null,
                React.createElement("span", { title: title },
                    React.createElement(PropertiesSelectorElements.DefaultPropertySelector, Object.assign({}, selectorInfo.selectorComponentProps))))));
    }));
}
function ProductPropertyRowRenderer({ conversionParameters, fieldGroup, fieldName, filterPrettyPrint, isQuantitySelectorActive, hidePropertyName, onQuantityChange, selectorInfo, translatePropertyValue, valueSourcesDict }) {
    const { isHidden, propertyName, label, selectorComponentProps } = selectorInfo;
    const valueSources = valueSourcesDict[propertyName] || [];
    return (React.createElement("tr", null,
        !hidePropertyName && (React.createElement(property_label_1.PropertyLabel, { labelText: label, isHidden: isHidden })),
        React.createElement(product_property_selector_1.ProductPropertySelector, { fieldName: fieldName, fieldGroup: fieldGroup, filterPrettyPrint: filterPrettyPrint, onPropertyFormatChanged: selectorComponentProps.onPropertyFormatChanged, onPropertyFormatCleared: selectorComponentProps.onPropertyFormatCleared, onPropertyFormatSelectorToggled: selectorComponentProps.onPropertyFormatSelectorToggled, onQuantityChange: onQuantityChange, valueSources: valueSources, selectorInfo: selectorInfo, conversionParameters: conversionParameters, isQuantitySelectorActive: isQuantitySelectorActive, translatePropertyValue: translatePropertyValue }),
        React.createElement("td", null,
            React.createElement(value_source_selector_1.ValueSourceSelector, { isLocked: selectorInfo.selectorComponentProps.readOnly, onChange: selectorComponentProps.onChange, selectedProperties: selectorComponentProps.selectedProperties, propertyName: propertyName, showCodes: selectorComponentProps.includeCodes, valueSources: valueSources }))));
}
//# sourceMappingURL=row-renderer.js.map